import { render, staticRenderFns } from "./view_Upsells.vue?vue&type=template&id=2332f0fd&scoped=true&"
import script from "./view_Upsells.vue?vue&type=script&lang=js&"
export * from "./view_Upsells.vue?vue&type=script&lang=js&"
import style0 from "./view_Upsells.vue?vue&type=style&index=0&id=2332f0fd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2332f0fd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
